import MessageGears from '../forms/message-gears';
import { getPageNodeGUID } from '../../../domain/common';
import ReactDOM from 'react-dom';

export const MG_SESSION_STORAGE_KEY = 'access-allowed-by-email';

const getSavedGuidsList = () => {

    let savedGuidsList: string[] = [];
    let savedGuidsVal = window.localStorage.getItem(MG_SESSION_STORAGE_KEY) || '';

    try{
        savedGuidsList = JSON.parse(savedGuidsVal) as string[];
    }
    catch(ex){}

    if(!Array.isArray(savedGuidsList)){
        savedGuidsList = [];
    }

    return savedGuidsList;
};

/**
 * check if page node guid has already been saved in session storage
 * used in case of popup
 */
const ifFormAlreadyVisited = () => {

    if(!window.localStorage) return false;

    const guid = getPageNodeGUID();
    if(!guid) return false;

    const savedGuidsList = getSavedGuidsList();
    const foundIndex = savedGuidsList.findIndex(item => item === guid);

    return foundIndex !== -1;
};

/**
 * https://jira.waves.com:8443/browse/DSWEB-191
 * if data-save-nodeguid="true" -> save the nodeguid (printed on page as guid) to a session storage called "access-allowed-by-email"
 */
export const saveNodeGUID = () => {

    if(!window.localStorage) return;

    const nodeGUID = getPageNodeGUID();
    if(!nodeGUID) return false;

    const savedGuidsList = getSavedGuidsList();
    const found = savedGuidsList.find(item => item === nodeGUID);

    if(!found){
        savedGuidsList.push(nodeGUID);
        window.localStorage.setItem(MG_SESSION_STORAGE_KEY, JSON.stringify(savedGuidsList));
    }
};

/**
 * find all elements with "data-form-name" data attribute
 * and render message gears form inside
 * https://wavesaudio.atlassian.net/browse/DSWEB-1837
 */
export const initMessageGearsForms = () => {
    const $forms = document.querySelectorAll('[data-form-name]');

    for(let i=0; i<$forms.length; i++){

        const $form = $forms[i];
        const formName = $form.getAttribute('data-form-name') || '';
        const showNames = $form.getAttribute('data-show-names') === 'true';
        const emailLabel = $form.getAttribute('data-email-label') || '';
        const emailPlaceholder = $form.getAttribute('data-email-placeholder') || '';
        const submitLabel = $form.getAttribute('data-submit-label') || 'Subscribe';
        const isInPopup = $form.getAttribute('data-popup') === 'true';
        const ifShouldHideOnSubmit = $form.getAttribute('data-hide-on-submit') === 'true';
        const ifShowTerms = $form.getAttribute('data-show-terms') === 'true';
        const ifSaveNodeGUID = $form.getAttribute('data-save-nodeguid') === 'true';
        const isCentered = $form.getAttribute('data-centered') === 'true';
        const width = $form.getAttribute('data-width');
        const height = $form.getAttribute('data-height');
        const visited = ifFormAlreadyVisited();
        const rguidEmail = $form.getAttribute('data-rguid-email');

        const children = $form.innerHTML;

        ReactDOM.render(
            <MessageGears
                formName={ formName }
                emailLabel={ emailLabel }
                emailPlaceholder={ emailPlaceholder }
                submitLabel={submitLabel}
                showNames={showNames}
                isInPopup={isInPopup}
                ifShouldHideOnSubmit={ifShouldHideOnSubmit}
                ifShowTerms={ifShowTerms}
                visited={visited}
                ifSaveNodeGUID={ifSaveNodeGUID}
                isCentered={isCentered}
                width={width}
                height={height}
                children={children}
                rguidEmail={rguidEmail}
            />,
            $form
        );
    }
};
